import React from "react";
import {
  Grid,
  Paper,
  Avatar,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  FormControl,
} from "@mui/material";
import {
  LockOutlinedIcon,
  VisibilityIcon as Visibility,
  VisibilityOffIcon as VisibilityOff,
} from "../../icons";
import { observer } from "mobx-react";
import { useRootStore } from "../../store/contexts";

export const ChangePasswordForm = observer(() => {
  const rootStore = useRootStore();

  const paperStyle = {
    padding: 20,
    height: "460px",
    width: 300,
    margin: "20px auto",
  };
  const avatarStyle = { backgroundColor: "success.main" };
  const btnstyle = {};

  const auth = rootStore.authStore;
  const lang = rootStore.langStore;

  const handleChangePasswordClick = async () => {
    await auth.changePassword();
    if (!auth.errorMessage) {
      await auth.logout();
      rootStore.router.goTo("/");
    }
  };

  const handleChangePassword = (event: any) => {
    auth.setPassword(event.target.value);
  };

  const handleChangeNewPassword = (event: any) => {
    auth.setNewPassword(event.target.value);
  };

  const handleChangeSeccondPassword = (event: any) => {
    auth.setSecondPassword(event.target.value);
  };

  const handleClickShowPassword = () => {
    auth.toggleShowPassword();
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Grid>
      <Paper elevation={10} style={paperStyle}>
        <Grid alignItems="center">
          <Avatar style={avatarStyle}>
            <LockOutlinedIcon />
          </Avatar>
          <h2>{lang.changePasswordLabel}</h2>
        </Grid>
        <FormControl>
          <TextField
            autoComplete={"current-password"}
            name={"password"}
            id={"password"}
            sx={{ m: 1 }}
            label={lang.passwordLabel}
            onChange={handleChangePassword}
            placeholder="Enter password"
            type={"password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {auth.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            required
          >
            {auth.password}
          </TextField>

          <TextField
            autoComplete={"current-password"}
            name={"password-new-1"}
            id={"password-new-1"}
            sx={{ m: 1 }}
            label={lang.newPasswordLabel}
            onChange={handleChangeNewPassword}
            placeholder="Enter password"
            type={auth.showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {auth.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            required
          >
            {auth.password}
          </TextField>

          <TextField
            helperText={auth.passwordsAreOk ? "" : lang.differentPasswords}
            autoComplete={"current-password"}
            name={"password-new-2"}
            id={"password-new-2"}
            sx={{ m: 1 }}
            label={lang.newPasswordLabel}
            onChange={handleChangeSeccondPassword}
            placeholder="Enter password"
            type={auth.showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position={"end"}>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {auth.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            fullWidth
            required
          >
            {auth.password}
          </TextField>

          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={btnstyle}
            fullWidth
            onClick={handleChangePasswordClick}
          >
            {lang.changePasswordLabel}
          </Button>
          <Typography color="error">{auth.errorMessage}</Typography>
        </FormControl>
      </Paper>
    </Grid>
  );
});
